"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { FlaskConical } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useExitAtExpiry } from "@/components/view-as/use-exit-at-expiry";
import { useReservedBannerSpace } from "@/components/view-as/use-reserved-banner-space";
import { useDemoActions } from "./use-demo-actions";

const DASHBOARD_PATH = "/dashboard";

export function DemoSiteBar({ expiresAt }: { expiresAt: number }) {
  const { exit, pending } = useDemoActions();
  useExitAtExpiry(expiresAt, exit);
  const pathname = usePathname();
  const onDashboard = pathname === DASHBOARD_PATH || pathname.startsWith(`${DASHBOARD_PATH}/`);
  const barRef = useReservedBannerSpace<HTMLDivElement>(!onDashboard);

  if (onDashboard) return null;

  return (
    <div
      ref={barRef}
      role="status"
      className="fixed inset-x-0 bottom-0 z-50 flex flex-wrap items-center gap-x-3 gap-y-2 border-t border-border bg-surface px-4 py-2 text-sm"
    >
      <FlaskConical className="size-4 shrink-0 text-muted-foreground" aria-hidden />
      <p className="min-w-0 flex-1 max-md:basis-[calc(100%-2rem)]">
        <span className="font-semibold text-foreground">Demo account</span>
        <span className="text-muted-foreground"> · Nothing here is real.</span>
      </p>
      <Button asChild variant="ghost" size="sm" className="max-md:ml-auto max-md:min-h-11">
        <Link href={DASHBOARD_PATH}>Back to dashboard</Link>
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="max-md:min-h-11"
        onClick={() => void exit()}
        isLoading={pending === "exit"}
        disabled={pending !== null}
      >
        Exit demo
      </Button>
    </div>
  );
}
